import { Box, Button, Skeleton } from "@mui/material";
import React from "react";
import { primaryButtonSx } from "./pvtaStyles";

interface IProps {
    isPending: boolean;
    form?: string;
    type?: "button" | "submit" | "reset";
    onClick?: () => void;
    label?: string;
}

export const SaveButton: React.FC<IProps> = ({ isPending, form, type, onClick, label }) => {
    const buttonLabel = label || 'Speichern';

    return (
        <Button
            sx={{ ...primaryButtonSx, float: "right", ml: 2 }}
            disabled={isPending}
            form={form}
            type={type}
            onClick={onClick}
        >
            {isPending ? (
                <Box display="flex" alignItems="center" gap={1}>
                    <span>{buttonLabel}</span>
                    <Skeleton variant="circular" width={20} height={20} />
                </Box>
            ) : (
                buttonLabel
            )}
        </Button>
    );
};
